// Do not edit.
import { ShaderStore } from "../../Engines/shaderStore.js";
var name = "kernelBlurVaryingDeclaration";
var shader = "varying vec2 sampleCoord{X};";
// Sideeffect
ShaderStore.IncludesShadersStore[name] = shader;
/** @hidden */
export var kernelBlurVaryingDeclaration = { name: name, shader: shader };
//# sourceMappingURL=kernelBlurVaryingDeclaration.js.map